module.exports = __webpack_public_path__ + "b7c9e1e4.woff";